// import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http'
// import { DatePipe } from '@angular/common'
// import { offset } from '@popperjs/core';
// declare let Plotly: any;
// @Injectable({
//     providedIn: 'root'
// })
// export class PlotlyService {

//     constructor(
//         private http: HttpClient) { }

//     //Plot Line  2 Y axis
//     plotTwoLineCustomGraph(title: string, plotDiv: string, x: Date[], y: number[], y1: number[], y1name, y2name) {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'F1',
//             marker: { color: 'blue' }
//         };
//         var trace2 = {
//             y: y1,
//             x: x,
//             name: 'F2',
//             yaxis: 'y2',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'red' }


//         };
//         let layout = {
//             title: title,
//             xaxis: {
//                 title: "Date",
//                 type: "Date",
//                domain: [0.1, 2]
//             },

//             yaxis:
//             {
//                 title:  y2name,

//                 titlefont: { color: 'red' },
//                 tickfont: { color: '#000' },
//                 linecolor: "#000",
//                 linewidth: "2",
//                 position: 0
//             },
//             yaxis2: {
//                 title: y1name,
//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.1,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             }
//         };

//         Plotly.newPlot(plotDiv, [trace, trace2], layout);

//     }

//     //added new if field 1 and 2 selected
//     plotTwoLineCustomGraphWithF1andF2(title: string, plotDiv: string, x: Date[], y: number[], y1: number[], y1name, y2name) {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'F1',
//             marker: { color: 'blue' },
//              yaxis: 'y1',
//         };
//         var trace2 = {
//             y: y1,
//             x: x,
//             name: 'F2',
//             yaxis: 'y2',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'red' }


//         };
//         let layout = {
//             title: title,
//             xaxis: {
//                 title: "Date",
//                 type: "Date",
//                domain: [0.1, 2],
//                gridcolor: "#000",
//                linecolor: "#000",         
//                linewidth: "2"
//             },

//             yaxis:
//             {
//                 title:  y2name,

//                 titlefont: { color: 'red' },
//                 tickfont: { color: '#000' },
//                 gridcolor: "#000",
//                 linecolor: "#000",        
//                 linewidth: "2",
//                 position: 0.03
//             },
//             yaxis2: {
//                 title: y1name,
//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',

//                 position: 0.1,
//                 gridcolor: "#000",
//                 linecolor: "#000",        
//                 linewidth: "2"
//             }
//         };

//         Plotly.newPlot(plotDiv, [trace, trace2], layout);

//     }
//     //added new if field 1 and field2 is selected with events
//      //added new if field 1 and 2 selected
//      plotTwoLineCustomGraphWithF1andF2WithEvents(title: string, plotDiv: string, x: Date[], y: number[], y1: number[], y1name, y2name,y1Event:string[],
//         eventdate:string[],maxField1) {
//             let shapes = []
//             let NoOfEvents=[]
//         let trace = {
//             x: x,
//             y: y,
//             name: 'F1',
//             yaxis: 'y1',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'red' }
//         };
//         var trace2 = {
//             y: y1,
//             x: x,
//             name: 'F2',
//             yaxis: 'y2',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'blue' }
//         };
//         for (let i = 0; i < eventdate.length; i++)
//             {
//                 NoOfEvents[i] = maxField1 * 1.1;
//             }
//         const data=[
//             {
//                  x: x,
//                  y:y,
//                  type:"scatter",
//                  mode:'markers',
//                  marker:{color:'red'},

//                  name:'F1'

//              },


//              {

//                  x:eventdate,
//                  y:NoOfEvents,
//                  mode:'markers',
//                  type: 'line',
//                  hoverinfo:"text",
//                  marker:{size: 10, symbol: 'triangle-down-open', color: '#bf7413'},

//                  text:y1Event,
//                  showlegend: false,
//                  name:'F1',
//                  xref: 'paper',
//                  yref: 'paper'
//              },
//              trace2,

//             ]

//              for (let i = 0; i < eventdate.length; i++) {
//                 shapes.push({
//                     type: "line",
//                     xref: "x",
//                     yref: "paper",
//                     x0: eventdate[i],
//                     y0: 0,
//                     x1: eventdate[i],
//                     y1: 1,
//                     line: {
//                       color: '#000',
//                       width: 0.3,

//                     },


//                  })
//                 }
//         let layout = {
//             title: title,
//             xaxis: {
//                 title: "Date",
//                 type: "Date",
//                domain: [0.1, 2],
//                gridcolor: '#000',
//                linecolor: '#000', linewidth:'2',
//             },

//             yaxis:
//             {
//                 title:  y2name,

//                 titlefont: { color: 'red' },
//                 tickfont: { color: '#000' },
//                 position: 0.03,
//                 gridcolor: '#000',
//                 linecolor: '#000', linewidth:'2',
//             },
//             yaxis2: {
//                 title: y1name,
//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',

//                 position: 0.1,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             },
//             shapes:shapes
//         };

//         Plotly.newPlot(plotDiv,data, layout);

//     }
//     //added new if field 1 and 3 selected
//     plotTwoLineCustomGraphF1andF3(title: string, plotDiv: string, x: Date[], y: number[], y1: number[], y1name, y2name) {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'F1',
//             marker: { color: 'red' }
//         };
//         var trace2 = {
//             y: y1,
//             x: x,
//             name: 'F3',
//             yaxis: 'y2',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'blue' }


//         };
//         let layout = {
//             title: title,
//             xaxis: {
//                 title: "Date",
//                 type: "Date",
//                domain: [0.1, 2],
//                gridcolor: "#000",
//                linecolor: "#000",
//                linewidth: "2",
//             },

//             yaxis:
//             {
//                 title:  y2name,

//                 titlefont: { color: 'red' },
//                 tickfont: { color: '#000' },
//                 linecolor: "#000",
//                 linewidth: "2",
//                 position: 0.03
//             },
//             yaxis2: {
//                 title: y1name,
//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.1,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             }
//         };

//         Plotly.newPlot(plotDiv, [trace, trace2], layout);

//     }
//      //added new if field 1 and 3 selected
//      plotTwoLineCustomGraphWithF1and3WithEvents(title: string, plotDiv: string, x: Date[], y: number[], y1: number[], y1name, y2name,y1Event:string[],
//         eventdate:string[],maxField1) {
//             let shapes = []
//             let NoOfEvents=[]
//         let trace = {
//             x: x,
//             y: y,
//             name: 'F1',
//             yaxis: 'y1',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'blue' }
//         };
//         var trace2 = {
//             y: y1,
//             x: x,
//             name: 'F3',
//             yaxis: 'y2',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'red' }
//         };
//         for (let i = 0; i < eventdate.length; i++)
//             {
//                 NoOfEvents[i] = maxField1 * 1.1;
//             }
//         const data=[
//             {
//                  x: x,
//                  y:y,
//                  type:"scatter",
//                  mode:'markers',
//                  marker:{color:'blue'},

//                  name:'F1'
//              },


//              {

//                  x:eventdate,
//                  y:NoOfEvents,
//                  mode:'markers',
//                  type: 'line',
//                  hoverinfo:"text",
//                  marker:{size: 10, symbol: 'triangle-down-open', color: '#bf7413'},
//                  text:y1Event,
//                  showlegend: false,
//                  xref: 'paper',
//                  yref: 'paper'
//              },
//              trace2,

//             ]
//             for (let i = 0; i < eventdate.length; i++) {
//              shapes.push({
//                  type: "line",
//                  xref: "x",
//                  yref: "paper",
//                  x0: eventdate[i],
//                  y0: 0,
//                  x1: eventdate[i],
//                  y1: 1,
//                  line: {
//                     color: '#000',
//                     width: 0.3,

//                   },


//               })
//              }

//         let layout = {
//             title: title,
//             xaxis: {
//                 title: "Date",
//                 type: "Date",
//                domain: [0.1, 2],
//                gridcolor: '#000',
//                linecolor: '#000', linewidth:'2',
//             },

//             yaxis:
//             {
//                 title:  y2name,

//                 titlefont: { color: 'red' },
//                 tickfont: { color: '#000' },
//                 gridcolor: '#000',
//                 linecolor: '#000', linewidth:'2',
//                 position: 0.03
//             },
//             yaxis2: {
//                 title: y1name,
//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',

//                 position: 0.1,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             },
//             shapes:shapes
//         };

//         Plotly.newPlot(plotDiv,data, layout);

//     }
//     //added new if field 2 and 3 selected
//     plotTwoLineCustomGraphF2andF3(title: string, plotDiv: string, x: Date[], y: number[], y1: number[], y2name, y1name) {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'F2',
//             marker: { color: 'red' }
//         };
//         var trace2 = {
//             y: y1,
//             x: x,
//             name: 'F3',
//             yaxis: 'y2',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'blue' }


//         };
//         let layout = {
//             title: title,
//             xaxis: {
//                 title: "Date",
//                 type: "Date",
//                domain: [0.1, 2],
//                gridcolor: '#000',
//                linecolor: '#000', linewidth:'2',
//             },

//             yaxis:
//             {
//                 title:  y1name,

//                 titlefont: { color: 'red' },
//                 tickfont: { color: '#000' },
//                 gridcolor: '#000',
//                 linecolor: '#000', linewidth:'2',
//                 position: 0.03,
//             },
//             yaxis2: {
//                 title: y2name,
//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.1,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             }
//         };

//         Plotly.newPlot(plotDiv, [trace, trace2], layout);

//     }
//      //added new if field 1 and 3 selected
//      plotTwoLineCustomGraphWithF2and3WithEvents(title: string, plotDiv: string, x: Date[], y: number[], y1: number[], y1name, y2name,y1Event:string[],
//         eventdate:string[],maxField1) {
//             let shapes = []
//             let NoOfEvents=[]
//         let trace = {
//             x: x,
//             y: y,
//             name: 'F2',
//             yaxis: 'y1',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'red' }
//         };
//         var trace2 = {
//             y: y1,
//             x: x,
//             name: 'F3',
//             yaxis: 'y2',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'blue' }
//         };
//         for (let i = 0; i < eventdate.length; i++)
//             {
//                 NoOfEvents[i] = maxField1 * 1.1;
//             }
//         const data=[
//             {
//                  x: x,
//                  y:y,
//                  type:"scatter",
//                  mode:'markers',
//                  marker:{color:'red'},

//                  name: 'F2',
//                  linewidth:1,
//              },


//              {

//                  x:eventdate,
//                  y:NoOfEvents,
//                  mode:'markers',
//                  type: 'line',
//                  hoverinfo:"text",
//                  marker:{size: 10, symbol: 'triangle-down-open', color: '#bf7413'},
//                  line: {
//                     color: '#000',
//                     width: 0.3,

//                   },

//                  text:y1Event,
//                  showlegend: false,
//                  xref: 'paper',
//                  yref: 'paper'
//              },
//              trace2,

//             ]
//             for (let i = 0; i < eventdate.length; i++) {
//              shapes.push({
//                  type: "line",
//                  xref: "x",
//                  yref: "paper",
//                  x0: eventdate[i],
//                  y0: 0,
//                  x1: eventdate[i],
//                  y1: 1,
//                  line: {
//                    color: '#000',
//                    width: 0.3,

//                  },


//               })
//              }

//         let layout = {
//             title: title,
//             xaxis: {
//                 title: "Date",
//                 type: "Date",
//                domain: [0.1, 2],
//                gridcolor: "#000",
//                linecolor: "#000",
//                linewidth: "2",
//             },

//             yaxis:
//             {
//                 title:  y2name,

//                 titlefont: { color: 'red' },
//                 tickfont: { color: '#000' },
//                 gridcolor: "#000",
//                 linecolor: "#000",
//                 linewidth: "2",
//                 position: 0.03
//             },
//             yaxis2: {
//                 title: y1name,
//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',

//                 position: 0.1,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             },
//             shapes:shapes
//         };

//         Plotly.newPlot(plotDiv,data, layout);

//     }
//     //Plot Line  3 Y axis
//     plotThreeLineCustomGraph(title: string, plotDiv: string, x: Date[], y: number[], y1: number[], y2: number[], y1name, y2name, y3name) {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'P1',
//         };
//         var trace2 = {
//             y: y1,
//             x: x,
//             name: 'P2',
//             yaxis: 'y2',
//             type: 'scatter',
//             mode: 'markers',
//             color: 'red'
//         };
//         var trace3 = {
//             y: y2,
//             x: x,
//             name: 'P3',
//             yaxis: 'y3',
//             type: 'scatter',
//             mode: 'markers'
//         };
//         let layout = {
//             title: title,

//             xaxis: {
//                 title: "Date",
//                 type: "Date",

//                 domain: [0.15, 4]
//             },

//             yaxis:
//             {
//                 title: y1name,

//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 linecolor: "#000",
//                 linewidth: "2",
//                 position: 0.15
//             },
//             yaxis2: {
//                 title: y2name,
//                 titlefont: { color: '#ff0000' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.1,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             },
//             yaxis3: {
//                 title: y3name,
//                 titlefont: { color: 'green' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.05,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             }
//         };

//         Plotly.newPlot(plotDiv, [trace, trace2, trace3], layout);

//     }

//     //Plot Line 4 Y axis
//     plotFourLineCustomGraph(title: string, plotDiv: string, x: Date[], y: number[], y1: number[], y2: number[], y3: number[], y1name, y2name, y3name, y4name) {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'P1',
//         };
//         var trace2 = {
//             y: y1,
//             x: x,
//             name: 'P2',
//             yaxis: 'y2',
//             type: 'scatter',
//             mode: 'markers',
//             color: 'red'
//         };
//         var trace3 = {
//             y: y2,
//             x: x,
//             name: 'P3',
//             yaxis: 'y3',
//             type: 'scatter',
//             mode: 'markers'
//         };
//         var trace4 = {
//             y: y3,
//             x: x,
//             name: 'P4',
//             yaxis: 'y4',
//             type: 'scatter',
//             mode: 'markers'
//         };
//         let layout = {
//             title: title,

//             xaxis: {
//                 title: "Date",
//                 type: "Date",

//                 domain: [0.2, 4]
//             },

//             yaxis:
//             {
//                 title: y1name,

//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 linecolor: "#000",
//                 linewidth: "2",
//                 position: 0.2
//             },
//             yaxis2: {
//                 title: y2name,
//                 titlefont: { color: '#ff0000' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.15,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             },
//             yaxis3: {
//                 title: y3name,
//                 titlefont: { color: 'green' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.1,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             },
//             yaxis4: {
//                 title: y4name,
//                 titlefont: { color: 'pink' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.05,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             }
//         };

//         Plotly.newPlot(plotDiv, [trace, trace2, trace3, trace4], layout);

//     }

//     //Plot Line  3 Y axis
//     plotFiveLineCustomGraph(title: string, plotDiv: string, x: Date[], y: number[], y1: number[], y2: number[], y3: number[], y4: number[], y1name, y2name, y3name, y4name, y5name) {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'P1',
//         };
//         var trace2 = {
//             y: y1,
//             x: x,
//             name: 'P2',
//             yaxis: 'y2',
//             type: 'scatter',
//             mode: 'markers',
//             color: 'red'
//         };
//         var trace3 = {
//             y: y2,
//             x: x,
//             name: 'P3',
//             yaxis: 'y3',
//             type: 'scatter',
//             mode: 'markers'
//         };
//         var trace4 = {
//             y: y3,
//             x: x,
//             name: 'P4',
//             yaxis: 'y4',
//             type: 'scatter',
//             mode: 'markers'
//         };
//         var trace5 = {
//             y: y4,
//             x: x,
//             name: 'P5',
//             yaxis: 'y5',
//             type: 'scatter',
//             mode: 'markers'
//         };
//         let layout = {
//             title: title,

//             xaxis: {
//                 title: "Date",
//                 type: "Date",

//                 domain: [0.25, 4]
//             },

//             yaxis:
//             {
//                 title: y1name,

//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 linecolor: "#000",
//                 linewidth: "2",
//                 position: 0.25
//             },
//             yaxis2: {
//                 title: y2name,
//                 titlefont: { color: '#ff0000' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.2,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             },
//             yaxis3: {
//                 title: y3name,
//                 titlefont: { color: 'green' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.15,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             },
//             yaxis4: {
//                 title: y4name,
//                 titlefont: { color: 'pink' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.1,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             },
//             yaxis5: {
//                 title: y5name,
//                 titlefont: { color: 'yellow' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.05,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             }
//         };

//         Plotly.newPlot(plotDiv, [trace, trace2, trace3, trace4, trace5], layout);

//     }

//     //custom graph with all fields selected(3). Custom graph with 3 Y axis.
//     plotLineCustomGraph(title: string, plotDiv: string, x: Date[], y: number[], y1: number[], y2: number[],y1name, y2name, y3name) {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'F1',
//             marker: { color: 'blue' },
//              yaxis: 'y1',
//         };
//         var trace2 = {
//             y: y1,
//             x: x,
//             name: 'F2',
//             yaxis: 'y2',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'red' }

//         };
//         var trace3 = {
//             y: y2,
//             x: x,
//             name: 'F3',
//             yaxis: 'y3',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'green' }


//         };

//         let layout = {
//             title: title,

//             xaxis: {
//                 title: "Date",
//                 type: "Date",

//                 domain: [0.16, 4],
//                 gridcolor: "#000",
//                 linecolor: "#000",
//                 linewidth: "2",
//             },

//             yaxis:
//             {
//                 title: y1name,

//                 titlefont: { color: 'blue' },
//                 tickfont: { color: 'blue' },
//                 linecolor: "#000",
//                 linewidth: "2",

//                 position: 0.15,
//                 side: 'left',

//             },
//             yaxis2: {
//                 title: y2name,
//                 titlefont: { color: 'red' },
//                 tickfont: { color: 'red' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',

//                 position:0.1,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             },
//             yaxis3: {
//                 title: y3name,
//                 titlefont: { color: 'green' },
//                 tickfont: { color: 'green' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',

//                 position: 0.05,
//                 gridcolor: "#000",
//                 linecolor: "#000",
//                 linewidth: "2"
//             },

//         };

//         Plotly.newPlot(plotDiv, [trace, trace2, trace3], layout);

//     }
//    //custom graph with all fields selected(3). Custom graph with 3 Y axis with events
//    plotLineCustomGraphWithEvents(title: string, plotDiv: string, x: Date[], y: number[], y1: number[], y2: number[], y1name, y2name, y3name,  y1Event:string[],
//     eventdate:string[],maxField1) 
//     {

//         let shapes = []
//         let NoOfEvents=[]
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'F1',
//             yaxis: 'y1',
//             marker: { color: 'blue' }
//         };
//         var trace2 = {
//             y: y1,
//             x: x,
//             name: 'F2',
//             yaxis: 'y2',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'red' }

//         };
//         var trace3 = {
//             y: y2,
//             x: x,
//             name: 'F3',
//             yaxis: 'y3',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'green' }


//         };
//         for (let i = 0; i < eventdate.length; i++)
//             {
//                 NoOfEvents[i] = maxField1 * 1.1;
//             }
//         const data=[
//             {
//                  x: x,
//                  y:y,
//                  type:"scatter",
//                  mode:'markers',
//                  marker:{color:'blue'},
//                  showlegend: true,
//                  name:'F1'

//              },


//              {

//                  x:eventdate,
//                  y:NoOfEvents,
//                  mode:'markers',
//                  type: 'line',
//                  hoverinfo:"text",
//                  marker:{size: 10, symbol: 'triangle-down-open', color: '#bf7413'},

//                  text:y1Event,
//                  showlegend: false,
//                  xref: 'paper',
//                  yref: 'paper',

//              },
//              trace2,
//              trace3

//             ]
//             for (let i = 0; i < eventdate.length; i++) {
//              shapes.push({
//                  type: "line",
//                  xref: "x",
//                  yref: "paper",
//                  x0: eventdate[i],
//                  y0: 0,
//                  x1: eventdate[i],
//                  y1: 1,
//                  line: {
//                    color: '#000',
//                    width: 0.3,

//                  },


//               })
//              }

//         let layout = {
//             title: title,

//             xaxis: {
//                 title: "Date",
//                 type: "Date",

//                 domain: [0.16, 4],
//                 gridcolor: '#000',
//                 linecolor: '#000', linewidth:'2',
//             },

//             yaxis:
//             {
//                 title: y1name,
//                 titlefont: { color: 'blue' },
//                 tickfont: { color: 'blue' },
//                 position: 0.15,
//                 side: 'left',
//                 gridcolor: '#000',
//                 linecolor: '#000', linewidth:'2',
//             },
//             yaxis2: {
//                 title: y2name,
//                 titlefont: { color: 'red' },
//                 tickfont: { color: 'red' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',

//                 position:0.1,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             },
//             yaxis3: {
//                 title: y3name,
//                 titlefont: { color: 'green' },
//                 tickfont: { color: 'green' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',

//                 position: 0.05,
//                 gridcolor: "#000",
//                 linecolor: "#000",
//                 linewidth: "2"
//             },
//             shapes:shapes
//         };

//         Plotly.newPlot(plotDiv,data, layout);


// }
//     //
//     plotLineWaranty(title: string, plotDiv: string, x: Date[], y: number[], graphType: any) {
//         let ytitle = "Feed Pressure (psi)"
//         if (graphType.Type == 1) {
//             ytitle = "Permeate Flow"
//         }
//         else {
//             ytitle = "Feed Pressure (psi)"
//         }

//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'F1',
//         };

//         let layout = {
//             title: title,

//             xaxis: {
//                 title: "Date",
//                 type: "Date",

//                 xaxis: { domain: [0.3, 0.7] },

//             },

//             yaxis:
//             {
//                 title: ytitle,

//                 titlefont: { color: '#1f77b4' },
//                 tickfont: { color: '#000' },
//                 linecolor: "#000",
//                 linewidth: "2",

//             },
//             shapes: [
//                 {
//                     type: 'line',
//                     xref: 'paper',
//                     x0: 0,
//                     y0: +graphType.MaxPermTds,
//                     x1: 1,
//                     y1: +graphType.MaxPermTds,
//                     line:{
//                         color: 'rgb(255, 0, 0)',
//                         width: 4,
//                         dash:'dot'
//                     }
//                 }
//             ]
//         };

//         Plotly.newPlot(plotDiv, [trace], layout);

//     }

// //custom graph with 1 Y axis
//     plotLine(title: string, plotDiv: string, x: Date[], y: number[], yaxisname) {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'F1',
//             marker: { color: 'blue' }

//         };

//         let layout = {
//             title: title,

//             xaxis: {
//                 title: "Date",
//                 type: "Date",

//                 xaxis: { domain: [0.3, 0.7] },

//                 gridcolor: "#000",
//                 linecolor: "#000",
//                 linewidth: "2",

//             },

//             yaxis:
//             {
//                 title: yaxisname,
//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 gridcolor: "#000",
//                 linecolor: "#000",
//                 linewidth: "2",

//             },

//         };

//         Plotly.newPlot(plotDiv, [trace], layout);

//     }
//     //custom graph with 1 Y axis and events
//     plotLineWithEvents(title: string, plotDiv: string, x: Date[], y: number[], yaxisname,y1Event:string[],
//         eventdate:string[],maxField1) {
//             let shapes = []
//             let NoOfEvents=[]

//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'F1',
//             marker: { color: 'blue' }

//         };
//         for (let i = 0; i < eventdate.length; i++)
//             {
//                 NoOfEvents[i] = maxField1 * 1.1;
//             }
//        const data=[
//        {
//             x: x,
//             y:y,
//             type:"scatter",
//             mode:'markers',
//             marker:{color:'blue'},
//             showlegend: true,
//             name:'F1'
//         },


//         {  
//             x:eventdate,
//             y:NoOfEvents,
//             mode:'markers',
//             type: 'line',
//             hoverinfo:"text",
//             marker:{size: 10, symbol: 'triangle-down-open', color: '#bf7413'},
//             linewidth:1,
//             text:y1Event,
//             showlegend: false,
//             xref: 'paper',
//             yref: 'paper'
//         },
//        ]
//        for (let i = 0; i < eventdate.length; i++) {
//         shapes.push({
//             type: "line",
//             xref: "x",
//             yref: "paper",
//             x0: eventdate[i],
//             y0: 0,
//             x1: eventdate[i],
//             y1: 1,
//             line: {
//                 color: '#000',
//                 width: 0.1,

//               },


//          })
//         }

//         let layout = {
//             title: title,
//             xaxis: {
//                 title: "Date",
//                 type: "Date",
//                 xaxis: { domain: [0.3, 0.7] },
//                 gridcolor: "#000",
//                 linecolor: "#000",
//                 linewidth: "2",

//             },

//             yaxis:
//             {
//                 title: yaxisname,
//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 gridcolor: "#000",
//                 linecolor: "#000",
//                 linewidth: "2",

//             },
//             shapes: shapes

//         };

//         Plotly.newPlot(plotDiv,data,layout);

//     }
//      //Primary Graph
//     plotLinePrimary(title: string, plotDiv: string, x: Date[], y: number[],yaxis:string) {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'F1',
//             marker: { color: 'blue' }

//         };

//         let layout = {
//             title: title,

//             xaxis: {
//                 title: "Date",
//                 type: "Date",
//                 xaxis: { domain: [0.3, 0.7] },
//                 gridcolor: "#000",
//                 linecolor: "#000",
//                 linewidth: "2",
//             },

//             yaxis:
//             {
//                 title: yaxis,

//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 gridcolor: "#000",
//                 linecolor: "#000",
//                 linewidth: "2",

//             },

//         };

//         Plotly.newPlot(plotDiv, [trace], layout);

//     }
//     plotLinePrimaryWithEvents(title: string, plotDiv: string, x: Date[], y: number[],y1Event: string[],eventdate,maxYaxisNpf : number,yaxis:string) {
//         let shapes = []
//         let NoOfEvents=[]
//         let trace = {
//             x: x,
//             y:y,
//             x1:x,
//             y1:y1Event,
//             name: 'F1',
//             marker: { color: 'blue' },
//             title: yaxis,
//         };
//         for (let i = 0; i < eventdate.length; i++)
//             {
//                 NoOfEvents[i] = maxYaxisNpf * 1.1;
//             }
//        const data=[
//        {
//             x: x,
//             y:y,
//             type:"scatter",
//             mode:'markers',
//             marker:{color:'blue'},
//             showlegend: true,
//             name:'F1'
//         },

//         {

//             x:eventdate,
//             y:NoOfEvents,
//             mode:'markers',
//             type: 'line',
//             hoverinfo:"text",
//             marker:{size: 10, symbol: 'triangle-down-open', color: '#bf7413'},

//             text:y1Event,
//             showlegend: false,
//             xref: 'paper',
//             yref: 'paper'


//         }

//        ]
//        for (let i = 0; i < eventdate.length; i++) {
//         shapes.push({
//             type: "line",
//             xref: "x",
//             yref: "paper",
//             x0: eventdate[i],
//             y0: 0,
//             x1: eventdate[i],
//             y1: 1,
//             line: {
//                 color: '#000',
//                 width: 0.1,

//               },


//          })
//         }
//        let layout={
//         title: title,
//          xaxis: {
//                 title: "Date",
//                 type: "Date",
//                 xaxis: { domain: [0.3, 0.7] },
//                 gridcolor: "#000",
//                    linecolor: "#000",
//                    linewidth: "2",
//             },

//             yaxis:
//             {
//                 title: yaxis,
//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 gridcolor: "#000",
//                    linecolor: "#000",
//                    linewidth: "2",

//             },
//             shapes: shapes
//        }


//         Plotly.newPlot(plotDiv,data,layout);


//     }
//     plotLine2(title: string, plotDiv: string, x: Date[], y: number[],yaxis:string)
//      {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'F1',
//             marker: { color: 'red' }
//         };

//         let layout = {
//             title: title,

//             xaxis: {
//                 title: "Date",
//                 type: "Date",
//                 xaxis: { domain: [0.3, 0.7] },
//                 gridcolor: "#000",
//                 linecolor: "#000",
//                 linewidth: "2",

//             },

//             yaxis:
//             {
//                     title: yaxis,
//                     titlefont: { color: 'red' },
//                     tickfont: { color: '#000' },
//                     gridcolor: "#000",
//                    linecolor: "#000",
//                    linewidth: "2",

//             },

//         };

//         Plotly.newPlot(plotDiv, [trace], layout);

//     }
//     plotLine2WithEvents(title: string, plotDiv: string, x: Date[], y: number[],y1Event: string[],eventdate,maxYaxisNsp,yaxis:string) {
//         let shapes = []
//         let NoOfEvents=[]
//         let trace = {
//             x: x,
//             y:y,
//             x1:x,
//             y1:y1Event,
//             name: 'F1',
//             marker: { color: 'red' },
//             title: yaxis,
//         };
//         for (let i = 0; i < eventdate.length; i++)
//             {
//                 NoOfEvents[i] = maxYaxisNsp * 1.1;
//             }
//        const data=[
//        {
//             x: x,
//             y:y,
//             type:"scatter",
//             mode:'markers',
//             marker:{color:'red'},
//             showlegend: true,
//             name:'F1'


//         },
//         {
//         x:eventdate,

//         y:NoOfEvents,
//         mode:'markers',
//         hoverinfo:"text",
//         marker:{size: 10, symbol: 'triangle-down-open', color: '#bf7413'},

//         text:y1Event,
//         showlegend: false,



//     }

//        ]
//        for (let i = 0; i < eventdate.length; i++) {
//         shapes.push({
//             type: "line",
//             xref: "x",
//             yref: "paper",
//             x0: eventdate[i],
//             y0: 0,
//             x1: eventdate[i],
//             y1: 1,
//             line: {
//                 color: '#000',
//                 width: 0.1,

//               },


//          })
//         }
//        let layout={
//         title: title,
//         xaxis: {
//                title: "Date",
//                type: "Date",
//                xaxis: { domain: [0.3, 0.7] },
//                gridcolor: "#000",
//                    linecolor: "#000",
//                    linewidth: "2",



//            },
//            yaxis:
//            {
//                title: yaxis,
//                titlefont: { color: 'red' },
//                tickfont: { color: '#000' },
//                gridcolor: "#000",
//                    linecolor: "#000",
//                    linewidth: "2",

//            },
//            shapes: shapes
//        }

//         Plotly.newPlot(plotDiv,data,layout);


//     }
//     plotLine3(title: string, plotDiv: string, x: Date[], y: number[],yaxis:string) {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'F1',
//             marker: { color: 'green' }
//         };

//         let layout = {
//             title: title,

//             xaxis: {
//                 title: "Date",
//                 type: "Date",
//                 xaxis: { domain: [0.3, 0.7] },
//                 gridcolor: "#000",
//                 linecolor: "#000",
//                 linewidth: "2",

//             },

//             yaxis:
//             {
//                 title: yaxis,

//                 titlefont: { color: 'green' },
//                 tickfont: { color: '#000' },
//                 gridcolor: "#000",
//                 linecolor: "#000",
//                 linewidth: "2",

//             },

//         };

//         Plotly.newPlot(plotDiv, [trace], layout);

//     }
//     plotLine3WithEvents(title: string, plotDiv: string, x: Date[], y: number[],y1Event: string[],eventdate,maxYaxisNdf,yaxis:string)
//     {
//         let shapes = []
//         let NoOfEvents=[]
//         let trace = {
//             x: x,
//             y:y,
//             x1:x,
//             y1:y1Event,
//             name: 'F1',
//             marker: { color: 'green' },
//             title: yaxis,
//         };
//         for (let i = 0; i < eventdate.length; i++)
//             {
//                 NoOfEvents[i] = maxYaxisNdf * 1.1;
//             }
//        const data=[
//        {
//             x: x,
//             y:y,
//             type:"scatter",
//             mode:'markers',
//             marker:{color:'green'},
//             showlegend: true,
//             name:'F1'


//         },
//         {
//             x:eventdate,

//             y:NoOfEvents,
//             type:"line",
//             mode:'markers',
//             hoverinfo:"text",
//             marker:{size: 10, symbol: 'triangle-down-open', color: '#bf7413'},

//             text:y1Event,
//             showlegend: false,


//     }

//        ]

//        for (let i = 0; i < eventdate.length; i++) {
//         shapes.push({
//             type: "line",
//             xref: "x",
//             yref: "paper",
//             x0: eventdate[i],
//             y0: 0,
//             x1: eventdate[i],
//             y1: 1,
//             line: {
//               color: '#000',
//               width: 0.3,
//             },


//          })
//         }
//        let layout={

//             title: title,

//             xaxis: {
//                     title: "Date",
//                     type: "Date",
//                      xaxis: { domain: [0.3, 0.7] },
//                     gridcolor: "#000",
//                     linecolor: "#000",
//                     linewidth: "2",

//                },
//                yaxis:
//                {
//                    title: yaxis,
//                    titlefont: { color: 'green' },
//                    tickfont: { color: '#000' },
//                    gridcolor: "#000",
//                    linecolor: "#000",
//                    linewidth: "2",

//                },
//                shapes: shapes


//        }


//         Plotly.newPlot(plotDiv,data,layout);
//     }
//     //

//     //comparison graph with 2 Y axis

//     plotTwoLineComparisonGraph(title: string, plotDiv: string, x: Date[], x2: Date[],y: number[], y1: number[], y1name, y2name) {
//         let trace = {
//             x: x,
//             y: y1,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'P1',
//             marker: { color: 'blue' }
//         };
//         var trace2 = {
//             y: y,
//             x: x2,
//             name: 'P2',
//             yaxis: 'y2',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'red' }


//         };
//         let layout = {
//             title: title,

//             xaxis: {
//                 title: "Date",
//                 type: "Date",

//                domain: [0.1, 2]
//             },

//             yaxis:
//             {
//                 title:  y2name,

//                 titlefont: { color: 'red' },
//                 tickfont: { color: '#000' },
//                 linecolor: "#000",
//                 linewidth: "2",

//                position: 0.03
//             },
//             yaxis2: {
//                 title: y1name,
//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.1,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             }
//         };

//         Plotly.newPlot(plotDiv, [trace, trace2], layout);

//     }

//     //comparison graph with  3 Y axis
//     plotThreeLineComparisonGraph(title: string, plotDiv: string, x: Date[], x2:Date[],x3:Date[],y: number[], y1: number[], y2: number[], y1name, y2name, y3name) {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'P1',
//             marker: { color: 'blue' }
//         };
//         var trace2 = {
//             y: y1,
//             x: x2,
//             name: 'P2',
//             yaxis: 'y2',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'red' }
//         };
//         var trace3 = {
//             y: y2,
//             x: x3,
//             name: 'P3',
//             yaxis: 'y3',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'green' }
//         };
//         let layout = {
//             title: title,

//             xaxis: {
//                 title: "Date",
//                 type: "Date",

//                 domain: [0.15, 4]
//             },

//             yaxis:
//             {
//                 title: y1name,

//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 linecolor: "#000",
//                 linewidth: "2",
//                 position: 0.15
//             },
//             yaxis2: {
//                 title: y2name,
//                 titlefont: { color: '#ff0000' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.1,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             },
//             yaxis3: {
//                 title: y3name,
//                 titlefont: { color: 'green' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.05,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             }
//         };

//         Plotly.newPlot(plotDiv, [trace, trace2, trace3], layout);

//     }

//     //Comparison graph with 4 Y axis
//     plotFourLineComparisonGraph(title: string, plotDiv: string, x: Date[],x2: Date[],x3: Date[],x4: Date[], y: number[], y1: number[], y2: number[], y3: number[], y1name, y2name, y3name, y4name) {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'P1',
//             marker: { color: 'blue' }
//         };
//         var trace2 = {
//             y: y1,
//             x: x2,
//             name: 'P2',
//             yaxis: 'y2',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'red' }
//         };
//         var trace3 = {
//             y: y2,
//             x: x3,
//             name: 'P3',
//             yaxis: 'y3',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'green' }
//         };
//         var trace4 = {
//             y: y3,
//             x: x4,
//             name: 'P4',
//             yaxis: 'y4',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'pink' }
//         };
//         let layout = {
//             title: title,

//             xaxis: {
//                 title: "Date",
//                 type: "Date",

//                 domain: [0.2, 4]
//             },

//             yaxis:
//             {
//                 title: y1name,

//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 linecolor: "#000",
//                 linewidth: "2",
//                 position: 0.2
//             },
//             yaxis2: {
//                 title: y2name,
//                 titlefont: { color: '#ff0000' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.15,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             },
//             yaxis3: {
//                 title: y3name,
//                 titlefont: { color: 'green' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.1,
//                 gridcolor: "#000",
//                 linecolor: "#000",        
//                 linewidth: "2"
//             },
//             yaxis4: {
//                 title: y4name,
//                 titlefont: { color: 'pink' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.05,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             }
//         };

//         Plotly.newPlot(plotDiv, [trace, trace2, trace3, trace4], layout);

//     }

//     //Comparison graph with 5 Y axis
//     plotFiveLineComparisonGraph(title: string, plotDiv: string, x: Date[],x2: Date[],x3: Date[],x4: Date[],x5: Date[], y: number[], y1: number[], y2: number[], y3: number[], y4: number[], y1name, y2name, y3name, y4name, y5name) {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: 'P1',
//             marker: { color: 'blue' }
//         };
//         var trace2 = {
//             y: y1,
//             x: x2,
//             name: 'P2',
//             yaxis: 'y2',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'red' }
//         };
//         var trace3 = {
//             y: y2,
//             x: x3,
//             name: 'P3',
//             yaxis: 'y3',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'green' }
//         };
//         var trace4 = {
//             y: y3,
//             x: x4,
//             name: 'P4',
//             yaxis: 'y4',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: '#FAA0A0' }
//         };
//         var trace5 = {
//             y: y4,
//             x: x5,
//             name: 'P5',
//             yaxis: 'y5',
//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: '#EEDC82' }
//         };
//         let layout = {
//             title: title,

//             xaxis: {
//                 title: "Date",
//                 type: "Date",

//                 domain: [0.25, 4]
//             },

//             yaxis:
//             {
//                 title: y1name,

//                 titlefont: { color: 'blue' },
//                 tickfont: { color: '#000' },
//                 linecolor: "#000",
//                 linewidth: "2",
//                 position: 0.25
//             },
//             yaxis2: {
//                 title: y2name,
//                 titlefont: { color: '#ff0000' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.2,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             },
//             yaxis3: {
//                 title: y3name,
//                 titlefont: { color: 'green' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.15,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             },
//             yaxis4: {
//                 title: y4name,
//                 titlefont: { color: 'pink' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.1,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             },
//             yaxis5: {
//                 title: y5name,
//                 titlefont: { color: '#EEDC82' },
//                 tickfont: { color: '#000' },
//                 anchor: 'free',
//                 overlaying: 'y',
//                 side: 'left',
//                 position: 0.05,
//                 gridcolor: "#000",
//                 linecolor: "#000",         
//                 linewidth: "2"
//             }
//         };

//         Plotly.newPlot(plotDiv, [trace, trace2, trace3, trace4, trace5], layout);

//     }


//     //conductivity profile graph
//     plotLineCpGraphWithDate1(title: string, plotDiv: string, x: string[], y: string[],date1:string) {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: date1,
//             marker: { color: 'blue' }

//         };

//         let layout = {
//             title: title,
//             xaxis: {
//                 title: "",
//                 type: "-",
//                domain: [0.1, 2]
//             },

//             yaxis:
//             {
//                 title: "Conductivity Profile",
//                 titlefont: { color: 'black' },
//                 tickfont: { color: '#000' },
//                 linecolor: "#000",
//                 linewidth: "2",
//                 mode: 'lines+markers',
//                 type: 'scatter'
//             },

//         };

//         Plotly.newPlot(plotDiv, [trace], layout);

//     }

//     plotLineCpGraphWithDate2(title: string, plotDiv: string, x: string[], y:string[], y1:string[],date1:string,date2:string) {
//         let trace = {
//             x: x,
//             y: y,
//             type: 'scatter',
//             mode: 'markers',
//             name: date1,
//             marker: { color: 'blue' }
//         };
//         var trace2 = {
//             y: y1,
//             x: x,
//             name: date2,

//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'red' }


//         };

//         let layout = {
//             title: title,

//             xaxis: {
//                 title: "",
//                 type: "",
//                 xaxis: { domain: [0.3, 0.7] },

//             },

//             yaxis:
//             {
//                 title: "Conductivity Profile",
//                 titlefont: { color: 'black' },
//                 tickfont: { color: '#000' },
//                 linecolor: "#000",
//                 linewidth: "0",
//                 mode: 'lines+markers',
//                 type: 'scatter'
//             },
//             yaxis2:
//             {
//                 title: "",
//                 titlefont: { color: 'red' },
//                 tickfont: { color: 'red' },
//                 linecolor: "#000",
//                 linewidth: "0",

//             },
//         };

//         Plotly.newPlot(plotDiv, [trace,trace2], layout);

//     }
//     plotLineCpGraphWithDate3(title: string, plotDiv: string, x: string[], y: string[],y1:string[],y2:string[],date1:string,date2:string,date3:string) {
//         let trace = {
//             x: x,
//             y: y,
//             xtype: '-',
//             type: 'scatter',
//             mode: 'markers',
//             name: date1,
//             marker: { color: 'blue' }
//         };
//         var trace2 = {
//             y: y1,
//             x: x,
//             xtype: '-',
//             name: date2,

//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'red' }


//         };
//         var trace3 = {
//             y: y2,
//             x: x,
//             xtype: '-',
//             xmode: 'markers',
//             name: date3,

//             type: 'scatter',
//             mode: 'markers',
//             marker: { color: 'green' }
//         };
//         let layout = {
//             title: title,

//             xaxis: {
//                 title: "",
//                 type: "",
//                 xaxis: { domain: [0.3, 0.7] },
//                 gridcolor: '#000',linecolor: '#000', linewidth:'2'
//             },

//             yaxis:
//             {
//                 title: "Conductivity Profile",
//                 titlefont: { color: 'black' },
//                 tickfont: { color: '#000' },
//                 linecolor: "#000",
//                 linewidth: "0",
//                 mode: 'lines+markers',
//                 type: 'scatter'
//             },
//             yaxis2:
//             {
//                 title: "",
//                 titlefont: { color: 'red' },
//                 tickfont: { color: 'red' },
//                 linecolor: "#000",
//                 linewidth: "0",

//             },
//             yaxis3: {
//                 title: "",
//                 titlefont: { color: 'green' },
//                 tickfont: { color: 'green' },
//                 linecolor: "#000",        
//                 linewidth: "0"
//             }
//         };

//         Plotly.newPlot(plotDiv, [trace,trace2,trace3], layout);

//     }
// }

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { offset } from '@popperjs/core';
declare let Plotly: any;
@Injectable({
  providedIn: 'root',
})
export class PlotlyService {
  constructor(private http: HttpClient) { }

  //Plot Line  2 Y axis
  plotTwoLineCustomGraph(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1: number[],
    y1name,
    y2name
  ) {
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'F1',
      marker: { color: 'blue' },
    };
    var trace2 = {
      y: y1,
      x: x,
      name: 'F2',
      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'red' },
    };
    let layout = {
      title: title,
      xaxis: {
        title: 'Date',
        type: 'Date',
        domain: [0.1, 2],
      },

      yaxis: {
        title: y2name,

        titlefont: { color: 'red' },
        tickfont: { color: '#000' },
        linecolor: '#000',
        linewidth: '2',
        position: 0,
      },
      yaxis2: {
        title: y1name,
        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
    };

    Plotly.newPlot(plotDiv, [trace, trace2], layout);
  }
//added by smita
plotf1andf2custom(
title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1: number[],
    y2name,
    y1name,
    stageLabel2: string,
    stageLabel3: string
  ) {
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'F1 - ' + stageLabel2,
      marker: { color: 'red' },
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };
    var trace2 = {
      y: y1,
      x: x,
      name: 'F2 - ' + stageLabel3,
      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'blue' },
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };
    let layout = {
      title: title,
      xaxis: {
        title: 'Date',
        type: 'Date',
        domain: [0.1, 2],
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },

      yaxis: {
        title: y1name + "- " + stageLabel3,

        titlefont: { color: 'red' },
        tickfont: { color: '#000' },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
        position: 0.03,
      },
      yaxis2: {
        title: y2name + " - " + stageLabel2,
        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      Dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, [trace, trace2], layout);

    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }


  //added new if field 1 and 2 selected   DONE
  plotTwoLineCustomGraphWithF1andF2(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1: number[],
    y1name,
    y2name,
    stage1Label: string,
    stage2Label: string
  ) {
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'F1 - ' + stage1Label,
      marker: { color: 'red' },
      yaxis: 'y1',
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    var trace2 = {
      y: y1,
      x: x,
      name: 'F2 - ' + stage2Label,
      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'blue' },
      
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    let layout = {
      title: title,
      xaxis: {
        title: 'Date',
        type: 'Date',
        domain: [0.1, 2],
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },

      yaxis: {
        title: y2name + " - " + stage2Label,

        titlefont: { color: 'red' },
        tickfont: { color: '#000' },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
        position: 0.03,
      },
      yaxis2: {
        title: y1name + " - " + stage1Label,
        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',

        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, [trace, trace2], layout);

    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }
  //added new if field 1 and field2 is selected with events
  //added new if field 1 and 2 selected  DONE
  plotTwoLineCustomGraphWithF1andF2WithEvents(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1: number[],
    y1name,
    y2name,
    y1Event: string[],
    eventdate: string[],
    maxField1,
    stage1Label: string,
    stage2Label: string
  ) {
    let shapes = [];
    let NoOfEvents = [];
    let trace = {
      x: x,
      y: y,
      name: 'F1',
      yaxis: 'y1',
      type: 'scatter',
      mode: 'markers',
    marker: { color: 'red' },
     
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };
    var trace2 = {
      y: y1,
      x: x,
      name: 'F2 - ' + stage2Label,
      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
    
      marker: { color: 'blue' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    for (let i = 0; i < eventdate.length; i++) {
      // NoOfEvents[i] = maxField1 * 1.1;
      NoOfEvents[i] = 0.95;
    }
    const data = [
      {
        x: x,
        y: y,
        type: 'scatter',
        mode: 'markers',
        marker: { color: 'red' },
        
        name: 'F1 - ' + stage1Label,
        unselected: {
          marker: { opacity: 1 }
        },
        selected: {
          marker: { opacity: 1 }
        }
      },

      {
        x: eventdate,
        y: NoOfEvents,
        yaxis: 'y3',
        mode: 'markers',
        type: 'line',
        hoverinfo: 'text',
        marker: { size: 10, symbol: 'triangle-down-open', color: '#bf7413' },

        text: y1Event,
        showlegend: false,
        name: 'F1',
        xref: 'paper',
        yref: 'paper',
      },
      trace2,
    ];

    for (let i = 0; i < eventdate.length; i++) {
      shapes.push({
        type: 'line',
        xref: 'x',
        yref: 'paper',
        x0: eventdate[i],
        y0: 0,
        x1: eventdate[i],
        y1: 1,
        line: {
          color: '#000',
          width: 0.3,
        },
      });
    }
    let layout = {
      title: title,
      xaxis: {
        title: 'Date',
        type: 'Date',
        domain: [0.1, 2],
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },

      yaxis: {
        title: y2name + " - " + stage2Label,

        titlefont: { color: 'red' },
        tickfont: { color: '#000' },
        position: 0.03,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis2: {
        title: y1name + " - " + stage1Label,
        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',

        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis3: {
        overlaying: 'y',
        side: 'right',
        showgrid: false,
        showticklabels: false,
        range: [0, 1],
        fixedrange: true
      },
      shapes: shapes,
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, data, layout);

    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }
  //added new if field 1 and 3 selected DONE
  plotTwoLineCustomGraphF1andF3(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1: number[],
    y1name,
    y2name,
    stage1Label: string,
    stage3Label: string
  ) {
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'F1 - ' + stage1Label,
      marker: { color: 'blue' },
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };
    var trace2 = {
      y: y1,
      x: x,
      name: 'F3 - ' + stage3Label,
      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'green' },
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };
    let layout = {
      title: title,
      xaxis: {
        title: 'Date',
        type: 'Date',
        domain: [0.1, 2],
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },

      yaxis: {
        title: y2name + " - " + stage3Label,

        titlefont: { color: 'green' },
        tickfont: { color: '#000' },
        linecolor: '#000',
        linewidth: '2',
        position: 0.03,
      },
      yaxis2: {
        title: y1name + " - " + stage1Label,
        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, [trace, trace2], layout);

    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }
  //added new if field 1 and 3 selected  DONE
  plotTwoLineCustomGraphWithF1and3WithEvents(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1: number[],
    y1name,
    y2name,
    y1Event: string[],
    eventdate: string[],
    maxField1,
    stage1Label: string,
    stage3Label: string
  ) {
    let shapes = [];
    let NoOfEvents = [];
    let trace = {
      x: x,
      y: y,
      name: 'F1 - ' + stage1Label,
      yaxis: 'y1',
      type: 'scatter',
      mode: 'markers',
      // marker: { color: 'blue' },
      marker: { color: 'green' },
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };
    var trace2 = {
      y: y1,
      x: x,
      name: 'F3 - ' + stage3Label,
      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      // marker: { color: 'green' },
      marker: { color: 'blue' },
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };
    for (let i = 0; i < eventdate.length; i++) {
      // NoOfEvents[i] = maxField1 * 1.1;
      NoOfEvents[i] = 0.95;
    }
    const data = [
      {
        x: x,
        y: y,
        type: 'scatter',
        mode: 'markers',
         //marker: { color: 'blue' },
        marker: { color: 'green' },
        name: 'F1 - ' + stage1Label,
        unselected: {
          marker: { opacity: 1 } // Keep unselected points fully visible
        },
        selected: {
          marker: { opacity: 1 } // Keep selected points fully visible
        }
      },

      {
        x: eventdate,
        y: NoOfEvents,
        yaxis: 'y3',
        mode: 'markers',
        type: 'line',
        hoverinfo: 'text',
        marker: { size: 10, symbol: 'triangle-down-open', color: '#bf7413' },
        text: y1Event,
        showlegend: false,
        xref: 'paper',
        yref: 'paper',
      },
      trace2,
    ];
    for (let i = 0; i < eventdate.length; i++) {
      shapes.push({
        type: 'line',
        xref: 'x',
        yref: 'paper',
        x0: eventdate[i],
        y0: 0,
        x1: eventdate[i],
        y1: 1,
        line: {
          color: '#000',
          width: 0.3,
        },
      });
    }

    let layout = {
      title: title,
      xaxis: {
        title: 'Date',
        type: 'Date',
        domain: [0.1, 2],
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },

      yaxis: {
        title: y2name + " - " + stage3Label,

        titlefont: { color: 'green' },
        tickfont: { color: '#000' },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
        position: 0.03,
      },
      yaxis2: {
        title: y1name + " - " + stage1Label,
        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',

        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis3: {
        overlaying: 'y',
        side: 'right',
        showgrid: false,
        showticklabels: false,
        range: [0, 1],
        fixedrange: true
      },
      shapes: shapes,
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, data, layout);


    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }
  //added new if field 2 and 3 selected DONE
  plotTwoLineCustomGraphF2andF3(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1: number[],
    y2name,
    y1name,
    stageLabel2: string,
    stageLabel3: string
  ) {
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'F2 - ' + stageLabel2,
      marker: { color: 'red' },
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };
    var trace2 = {
      y: y1,
      x: x,
      name: 'F3 - ' + stageLabel3,
      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'green' },
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };
    let layout = {
      title: title,
      xaxis: {
        title: 'Date',
        type: 'Date',
        domain: [0.1, 2],
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },

      yaxis: {
        title: y1name + "- " + stageLabel3,

        titlefont: { color: 'green' },
        tickfont: { color: '#000' },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
        position: 0.03,
      },
      yaxis2: {
        title: y2name + " - " + stageLabel2,
        titlefont: { color: 'red' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      Dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, [trace, trace2], layout);

    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }
  //added new if field 1 and 3 selected DONE
  plotTwoLineCustomGraphWithF2and3WithEvents(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1: number[],
    y1name,
    y2name,
    y1Event: string[],
    eventdate: string[],
    maxField1,
    stageLabel2: string,
    stageLabel3: string
  ) {
    let shapes = [];
    let NoOfEvents = [];
    let trace = {
      x: x,
      y: y,
      name: 'F2 - ' + stageLabel2,
      yaxis: 'y1',
      type: 'scatter',
      mode: 'markers',
      //marker: { color: 'red' },
      marker: { color: 'green' },
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };
    var trace2 = {
      y: y1,
      x: x,
      name: 'F3 - ' + stageLabel3,
      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      // marker: { color: 'green' },
      marker: { color: 'red' },
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };
    for (let i = 0; i < eventdate.length; i++) {
      // NoOfEvents[i] = maxField1 * 1.1;
      NoOfEvents[i] = 0.95;
    }
    const data = [
      {
        x: x,
        y: y,
        type: 'scatter',
        mode: 'markers',
        marker: { color: 'green' },

        name: 'F2 - ' + stageLabel2,
        linewidth: 1,
        unselected: {
          marker: { opacity: 1 } // Keep unselected points fully visible
        },
        selected: {
          marker: { opacity: 1 } // Keep selected points fully visible
        }
      },

      {
        x: eventdate,
        y: NoOfEvents,
        yaxis: 'y3',
        mode: 'markers',
        type: 'line',
        hoverinfo: 'text',
        marker: { size: 10, symbol: 'triangle-down-open', color: '#bf7413' },
        line: {
          color: '#000',
          width: 0.3,
        },

        text: y1Event,
        showlegend: false,
        xref: 'paper',
        yref: 'paper',
      },
      trace2,
    ];
    for (let i = 0; i < eventdate.length; i++) {
      shapes.push({
        type: 'line',
        xref: 'x',
        yref: 'paper',
        x0: eventdate[i],
        y0: 0,
        x1: eventdate[i],
        y1: 1,
        line: {
          color: '#000',
          width: 0.3,
        },
      });
    }

    let layout = {
      title: title,
      xaxis: {
        title: 'Date',
        type: 'Date',
        domain: [0.1, 2],
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },

      yaxis: {
        title: y2name + " - " + stageLabel3,

        titlefont: { color: 'green' },
        tickfont: { color: '#000' },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
        position: 0.03,
      },
      yaxis2: {
        title: y1name + " - " + stageLabel2,
        titlefont: { color: 'red' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',

        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis3: {
        overlaying: 'y',
        side: 'right',
        showgrid: false,
        showticklabels: false,
        range: [0, 1],
        fixedrange: true
      },
      shapes: shapes,
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, data, layout);

    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }


  //Plot Line  3 Y axis
  plotThreeLineCustomGraph(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1: number[],
    y2: number[],
    y1name,
    y2name,
    y3name
  ) {
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'P1',
    };
    var trace2 = {
      y: y1,
      x: x,
      name: 'P2',
      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      color: 'red',
    };
    var trace3 = {
      y: y2,
      x: x,
      name: 'P3',
      yaxis: 'y3',
      type: 'scatter',
      mode: 'markers',
    };
    let layout = {
      title: title,

      xaxis: {
        title: 'Date',
        type: 'Date',

        domain: [0.15, 4],
      },

      yaxis: {
        title: y1name,

        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        linecolor: '#000',
        linewidth: '2',
        position: 0.15,
      },
      yaxis2: {
        title: y2name,
        titlefont: { color: '#ff0000' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis3: {
        title: y3name,
        titlefont: { color: 'green' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.05,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
    };

    Plotly.newPlot(plotDiv, [trace, trace2, trace3], layout);
  }

  //Plot Line 4 Y axis
  plotFourLineCustomGraph(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1: number[],
    y2: number[],
    y3: number[],
    y1name,
    y2name,
    y3name,
    y4name
  ) {
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'P1',
    };
    var trace2 = {
      y: y1,
      x: x,
      name: 'P2',
      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      color: 'red',
    };
    var trace3 = {
      y: y2,
      x: x,
      name: 'P3',
      yaxis: 'y3',
      type: 'scatter',
      mode: 'markers',
    };
    var trace4 = {
      y: y3,
      x: x,
      name: 'P4',
      yaxis: 'y4',
      type: 'scatter',
      mode: 'markers',
    };
    let layout = {
      title: title,

      xaxis: {
        title: 'Date',
        type: 'Date',

        domain: [0.2, 4],
      },

      yaxis: {
        title: y1name,

        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        linecolor: '#000',
        linewidth: '2',
        position: 0.2,
      },
      yaxis2: {
        title: y2name,
        titlefont: { color: '#ff0000' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.15,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis3: {
        title: y3name,
        titlefont: { color: 'green' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis4: {
        title: y4name,
        titlefont: { color: 'pink' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.05,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
    };

    Plotly.newPlot(plotDiv, [trace, trace2, trace3, trace4], layout);
  }

  //Plot Line  3 Y axis
  plotFiveLineCustomGraph(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1: number[],
    y2: number[],
    y3: number[],
    y4: number[],
    y1name,
    y2name,
    y3name,
    y4name,
    y5name
  ) {
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'P1',
    };
    var trace2 = {
      y: y1,
      x: x,
      name: 'P2',
      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      color: 'red',
    };
    var trace3 = {
      y: y2,
      x: x,
      name: 'P3',
      yaxis: 'y3',
      type: 'scatter',
      mode: 'markers',
    };
    var trace4 = {
      y: y3,
      x: x,
      name: 'P4',
      yaxis: 'y4',
      type: 'scatter',
      mode: 'markers',
    };
    var trace5 = {
      y: y4,
      x: x,
      name: 'P5',
      yaxis: 'y5',
      type: 'scatter',
      mode: 'markers',
    };
    let layout = {
      title: title,

      xaxis: {
        title: 'Date',
        type: 'Date',

        domain: [0.25, 4],
      },

      yaxis: {
        title: y1name,

        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        linecolor: '#000',
        linewidth: '2',
        position: 0.25,
      },
      yaxis2: {
        title: y2name,
        titlefont: { color: '#ff0000' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.2,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis3: {
        title: y3name,
        titlefont: { color: 'green' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.15,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis4: {
        title: y4name,
        titlefont: { color: 'pink' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis5: {
        title: y5name,
        titlefont: { color: 'yellow' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.05,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
    };

    Plotly.newPlot(plotDiv, [trace, trace2, trace3, trace4, trace5], layout);
  }

  //custom graph with all fields selected(3). Custom graph with 3 Y axis. DONE
  plotLineCustomGraph(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1: number[],
    y2: number[],
    y1name,
    y2name,
    y3name,
    stage1: string,
    stage2: string,
    stage3: string
  ) {
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'F1 - ' + stage1,
      marker: { color: 'blue' },
      yaxis: 'y1',
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    var trace2 = {
      y: y1,
      x: x,
      name: 'F2 - ' + stage2,
      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'red' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    var trace3 = {
      y: y2,
      x: x,
      name: 'F3 - ' + stage3,
      yaxis: 'y3',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'green' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };

    let layout = {
      title: title,

      xaxis: {
        title: 'Date',
        type: 'Date',

        domain: [0.16, 4],
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },

      yaxis: {
        title: y1name + " - " + stage1,

        titlefont: { color: 'blue' },
        tickfont: { color: 'blue' },
        linecolor: '#000',
        linewidth: '2',

        position: 0.15,
        side: 'left',
      },
      yaxis2: {
        title: y2name + " - " + stage2,
        titlefont: { color: 'red' },
        tickfont: { color: 'red' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',

        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis3: {
        title: y3name + " - " + stage3,
        titlefont: { color: 'green' },
        tickfont: { color: 'green' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',

        position: 0.05,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, [trace, trace2, trace3], layout);

    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }
  //custom graph with all fields selected(3). Custom graph with 3 Y axis with events DONE
  plotLineCustomGraphWithEvents(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1: number[],
    y2: number[],
    y1name,
    y2name,
    y3name,
    y1Event: string[],
    eventdate: string[],
    maxField1,
    stage1: string,
    stage2: string,
    stage3: string
  ) {
    let shapes = [];
    let NoOfEvents = [];
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      //   name: 'F1',
      name: `F1 - ${stage1}`,

      yaxis: 'y1',
      marker: { color: 'blue' },
    };
    var trace2 = {
      y: y1,
      x: x,
      //   name: 'F2',
      name: `F2 - ${stage2}`,

      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'red' },
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };
    var trace3 = {
      y: y2,
      x: x,
      //   name: 'F3',
      name: `F3 - ${stage3}`,

      yaxis: 'y3',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'green' },
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };
    for (let i = 0; i < eventdate.length; i++) {
      // NoOfEvents[i] = maxField1 * 1.1;
      NoOfEvents[i] = 0.95;
    }
    const data = [
      {
        x: x,
        y: y,
        type: 'scatter',
        mode: 'markers',
        marker: { color: 'blue' },
        showlegend: true,
        // name: 'F1',
        name: `F1 - ${stage1}`,
        unselected: {
          marker: { opacity: 1 } // Keep unselected points fully visible
        },
        selected: {
          marker: { opacity: 1 } // Keep selected points fully visible
        }
      },

      {
        x: eventdate,
        y: NoOfEvents,
        mode: 'markers',
        yaxis: 'y4',
        type: 'line',
        hoverinfo: 'text',
        marker: { size: 10, symbol: 'triangle-down-open', color: '#bf7413' },

        text: y1Event,
        showlegend: false,
        xref: 'paper',
        yref: 'paper',
      },
      trace2,
      trace3,
    ];
    for (let i = 0; i < eventdate.length; i++) {
      shapes.push({
        type: 'line',
        xref: 'x',
        yref: 'paper',
        x0: eventdate[i],
        y0: 0,
        x1: eventdate[i],
        y1: 1,
        line: {
          color: '#000',
          width: 0.3,
        },
      });
    }

    let layout = {
      title: title,
      showlegend: true,
      xaxis: {
        title: 'Date',
        type: 'Date',

        domain: [0.16, 4],
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },

      yaxis: {
        // title: y1name,
        title: `${y1name} (${stage1})`,
        titlefont: { color: 'blue' },
        tickfont: { color: 'blue' },
        position: 0.15,
        side: 'left',
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis2: {
        // title: y2name,
        title: `${y2name} (${stage2})`,
        titlefont: { color: 'red' },
        tickfont: { color: 'red' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',

        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis3: {
        // title: y3name,
        title: `${y3name} (${stage3})`,
        titlefont: { color: 'green' },
        tickfont: { color: 'green' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',

        position: 0.05,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis4: {
        overlaying: 'y',
        side: 'right',
        showgrid: false,
        showticklabels: false,
        range: [0, 1],
        fixedrange: true
      },
      shapes: shapes,
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, data, layout);
    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }

  }
  // Warranty Plot DONE
  plotLineWaranty(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    graphType: any,
    stageLabel: string,
  ) {
    let ytitle = 'Feed Pressure (psi)';
    if (graphType.Type == 1) {
      ytitle = 'Permeate Flow';
    } else {
      ytitle = 'Feed Pressure (psi)';
    }

    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'F1 - ' + stageLabel,
      showlegend: true,
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };

    let layout = {
      title: title,
      showlegend: true,
      xaxis: {
        title: 'Date',
        type: 'Date',

        xaxis: { domain: [0.3, 0.7] },
      },

      yaxis: {
        title: ytitle + " - " + stageLabel,

        titlefont: { color: '#1f77b4' },
        tickfont: { color: '#000' },
        linecolor: '#000',
        linewidth: '2',
      },
      shapes: [
        {
          type: 'line',
          xref: 'paper',
          x0: 0,
          y0: +graphType.MaxPermTds,
          x1: 1,
          y1: +graphType.MaxPermTds,
          line: {
            color: 'rgb(255, 0, 0)',
            width: 4,
            dash: 'dot',
          },
        },
      ],
      dragmode: 'lasso',
    };

    const config = {
      modeBarButtonsToAdd: ['lasso2d'],
      displayModeBar: true,
    };
    Plotly.newPlot(plotDiv, [trace], layout);

    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }
  //custom graph with 1 Y axis DONE
  plotLine(title: string, plotDiv: string, x: Date[], y: number[], yaxisname, stage1Label: string,) {
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'F1 - ' + stage1Label,
      marker: { color: 'blue' },

    };

    let layout = {
      title: title,
      showlegend: true,
      xaxis: {
        title: 'Date',
        type: 'Date',

        xaxis: { domain: [0.3, 0.7] },

        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },

      yaxis: {
        title: yaxisname + " - " + stage1Label,
        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, [trace], layout);

    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }

  //custom graph with 1 Y axis and events DONE
  plotLineWithEvents(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    yaxisname,
    y1Event: string[],
    eventdate: string[],
    maxField1,
    stageLabel: string,
  ) {
    let shapes = [];
    let NoOfEvents = [];

    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'F1',
      marker: { color: 'blue' },
    };
    for (let i = 0; i < eventdate.length; i++) {
      // NoOfEvents[i] = maxField1 * 1.1;
      NoOfEvents[i] = 0.95;
    }
    const data = [
      {
        x: x,
        y: y,
        type: 'scatter',
        mode: 'markers',
        marker: { color: 'blue' },
        showlegend: true,
        name: 'F1 - ' + stageLabel,
        unselected: {
          marker: { opacity: 1 } // Keep unselected points fully visible
        },
        selected: {
          marker: { opacity: 1 } // Keep selected points fully visible
        }
      },

      {
        x: eventdate,
        y: NoOfEvents,
        yaxis: 'y2',
        mode: 'markers',
        type: 'line',
        hoverinfo: 'text',
        marker: { size: 10, symbol: 'triangle-down-open', color: '#bf7413' },
        linewidth: 1,
        text: y1Event,
        showlegend: false,
        xref: 'paper',
        yref: 'paper',
      },
    ];
    for (let i = 0; i < eventdate.length; i++) {
      shapes.push({
        type: 'line',
        xref: 'x',
        yref: 'paper',
        x0: eventdate[i],
        y0: 0,
        x1: eventdate[i],
        y1: 1,
        line: {
          color: '#000',
          width: 0.1,
        },
      });
    }

    let layout = {
      title: title,
      xaxis: {
        title: 'Date',
        type: 'Date',
        xaxis: { domain: [0.3, 0.7] },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },

      yaxis: {
        title: yaxisname + " - " + stageLabel,
        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis2: {
        overlaying: 'y',
        side: 'right',
        showgrid: false,
        showticklabels: false,
        range: [0, 1],
        fixedrange: true
      },
      shapes: shapes,
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, data, layout);

    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }

  // DONE
  //Primary Graph
  // plotLinePrimary(
  //   title: string,
  //   plotDiv: string,
  //   x: Date[],
  //   y: number[],
  //   yaxis: string,
  //   stageLabel: string,
  //   isMobileView : boolean 
  // ) {
  //   let trace = {
  //     x: x,
  //     y: y,
  //     type: 'scatter',
  //     mode: 'markers',
  //     name: 'F1',
  //     marker: { color: 'blue' },
  //   };
  //   const data = [
  //     {
  //       x: x,
  //       y: y,
  //       type: 'scatter',
  //       mode: 'markers',
  //       name: 'F1 - ' + stageLabel, 
  //       marker: { color: 'blue',size: window.innerWidth < 768 ? 3 : 5 },
  //       showlegend: !isMobileView,
  //       legendgroup: 'group1',

  //     },
  //     // {
  //     //     x: x,
  //     //     y: y,
  //     //     type: 'scatter',
  //     //     mode: 'markers',
  //     //     name: 'Stage : ' + stageLabel,
  //     //     marker: { color: 'blue'},
  //     //     showlegend: true,
  //     //     legendgroup: 'group1',
  //     //     hoverinfo: 'skip'
  //     // }
  //   ];


  //   let layout = {
  //     title: title,
  //     showlegend: !isMobileView,  
  //     xaxis: {
  //       title: 'Date',
  //       type: 'Date',
  //       xaxis: { domain: [0.3, 0.7] },
  //       gridcolor: '#000',
  //       linecolor: '#000',
  //       linewidth: '2',
  //     },

  //     yaxis: {
  //       title: yaxis,

  //       titlefont: { color: 'blue' },
  //       tickfont: { color: '#000' },
  //       gridcolor: '#000',
  //       linecolor: '#000',
  //       linewidth: '2',
  //     },

  //   };

  //   // Plotly.newPlot(plotDiv, [trace], layout);
  //   Plotly.newPlot(plotDiv, data, layout);
  // }
  plotLinePrimary(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    yaxis: string,
    stageLabel: string,
    // isMobileView : boolean 
  ) {
    //   const isMobile = isMobileView === true;
    // const legendText = isMobile 
    //   ? stageLabel
    //   : 'F1 - ' + stageLabel;

    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'F1',
      marker: { color: 'blue' },
    };
    const data = [
      {
        x: x,
        y: y,
        type: 'scatter',
        mode: 'markers',
        name: 'F1 - ' + stageLabel,
        marker: { color: 'blue' },
        showlegend: true,
        legendgroup: 'group1',
        unselected: {
          marker: { opacity: 1 } // Keep unselected points fully visible
        },
        selected: {
          marker: { opacity: 1 } // Keep selected points fully visible
        }
      }
    ];


    let layout = {
      title: title,
      showlegend: true,
      //   legend: isMobile ? {
      //   orientation: 'h',
      //   x: 0.5,
      //   xanchor: 'center',
      //   y: 1.15,
      //   yanchor: 'top',
      //   font: { size: 10 }
      // } : {
      //   orientation: 'v',
      //   x: 1.02,
      //   xanchor: 'left',
      //   y: 1,
      //   yanchor: 'top',
      //   font: { size: 12 }
      // },
      xaxis: {
        title: 'Date',
        type: 'date',  // ✅ Changed from 'Date' to 'date'
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: 2,  // ✅ Changed from '2' to 2 (number)
      },
      yaxis: {
        title: yaxis,
        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: 2,  // ✅ Changed from '2' to 2 (number)
      },

      // margin: isMobile ? {
      //   l: 50,
      //   r: 20,
      //   t: 80,
      //   b: 50
      // } : {
      //   l: 80,
      //   r: 150,
      //   t: 100,
      //   b: 80
      // },
      dragmode: 'lasso',
    };
    Plotly.newPlot(plotDiv, data, layout);

    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }
  //  plotLinePrimary(title: string, plotDiv: string, x: Date[], y: number[],yaxis:string) {
  //       let trace = {
  //           x: x,
  //           y: y,
  //           type: 'scatter',
  //           mode: 'markers',
  //           name: 'F1',
  //           marker: { color: 'blue' }

  //       };

  //       let layout = {
  //           title: title,

  //           xaxis: {
  //               title: "Date",
  //               type: "Date",
  //               xaxis: { domain: [0.3, 0.7] },
  //               gridcolor: "#000",
  //               linecolor: "#000",
  //               linewidth: "2",
  //           },

  //           yaxis:
  //           {
  //               title: yaxis,

  //               titlefont: { color: 'blue' },
  //               tickfont: { color: '#000' },
  //               gridcolor: "#000",
  //               linecolor: "#000",
  //               linewidth: "2",

  //           },

  //       };

  //       Plotly.newPlot(plotDiv, [trace], layout);

  //   }

  //   plotLinePrimaryWithEvents(
  //     title: string,
  //     plotDiv: string,
  //     x: Date[],
  //     y: number[],
  //     y1Event: string[],
  //     eventdate,
  //     maxYaxisNpf: number,
  //     yaxis: string,
  //     stageLabel: string,
  //     isMobileView : boolean = false
  //   ) {
  //     let shapes = [];
  //     let NoOfEvents = [];
  //     let trace = {
  //       x: x,
  //       y: y,
  //       x1: x,
  //       y1: y1Event,
  //       name: 'F1',
  //       legendgroup: 'group1',
  //       marker: { color: 'blue' },
  //       title: yaxis,
  //     };
  //     for (let i = 0; i < eventdate.length; i++) {
  //       NoOfEvents[i] = maxYaxisNpf * 1.1;
  //     }
  //     const data = [
  //       {
  //     x: x,
  //     y: y,
  //     type: 'scatter',
  //     mode: 'markers',
  //     name: 'F1 - ' + stageLabel,  // ✅ Combined label
  //     marker: { color: 'blue' },
  //     showlegend: !isMobileView,
  //     legendgroup: 'group1'
  // },
  //     //   {
  //     //     x: x,
  //     //     y: y,
  //     //     type: 'scatter',
  //     //     mode: 'markers',
  //     //     marker: { color: 'blue' },
  //     //     showlegend: true,
  //     //     name: 'Stage : ' + stageLabel,
  //     //     legendgroup: 'group1',
  //     //     hoverinfo: 'skip',
  //     //   },
  //       {
  //         x: eventdate,
  //         y: NoOfEvents,
  //         mode: 'markers',
  //         type: 'line',
  //         hoverinfo: 'text',
  //         marker: { size: 10, symbol: 'triangle-down-open', color: '#bf7413' },

  //         text: y1Event,
  //         showlegend: false,
  //         xref: 'paper',
  //         yref: 'paper',
  //       },
  //     ];
  //     for (let i = 0; i < eventdate.length; i++) {
  //       shapes.push({
  //         type: 'line',
  //         xref: 'x',
  //         yref: 'paper',
  //         x0: eventdate[i],
  //         y0: 0,
  //         x1: eventdate[i],
  //         y1: 1,
  //         line: {
  //           color: '#000',
  //           width: 0.1,
  //         },
  //       });
  //     }
  //     let layout = {
  //       title: title,
  //       showlegend: !isMobileView,  
  //       xaxis: {
  //         title: 'Date',
  //         type: 'Date',
  //         xaxis: { domain: [0.3, 0.7] },
  //         gridcolor: '#000',
  //         linecolor: '#000',
  //         linewidth: '2',
  //       },

  //       yaxis: {
  //         title: yaxis,
  //         titlefont: { color: 'blue' },
  //         tickfont: { color: '#000' },
  //         gridcolor: '#000',
  //         linecolor: '#000',
  //         linewidth: '2',
  //       },
  //       shapes: shapes,
  //     };

  //     Plotly.newPlot(plotDiv, data, layout);
  //   }

  plotLinePrimaryWithEvents(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1Event: string[],
    eventdate,
    maxYaxisNpf: number,
    yaxis: string,
    stageLabel: string,
    isMobileView: boolean = false
  ) {
    // ✅ Ensure isMobileView is a valid boolean
    const isMobile = isMobileView === true;

    // ✅ Use shorter legend text for mobile
    const legendText = isMobile
      ? stageLabel
      : 'F1 - ' + stageLabel;

    let shapes = [];
    let NoOfEvents = [];

    for (let i = 0; i < eventdate.length; i++) {
      // NoOfEvents[i] = maxYaxisNpf * 1.1;
      NoOfEvents[i] = 0.95;  // Position at 95% height instead of 100%;
    }

    const data = [
      {
        x: x,
        y: y,
        type: 'scatter',
        mode: 'markers',
        name: legendText,
        marker: { color: 'blue', size: isMobile ? 3 : 5 },
        showlegend: true,
        legendgroup: 'group1',
        unselected: {
          marker: { opacity: 1 } // Keep unselected points fully visible
        },
        selected: {
          marker: { opacity: 1 } // Keep selected points fully visible
        }
      },
      {
        x: eventdate,
        y: NoOfEvents,
        yaxis: 'y2',
        mode: 'markers',
        type: 'scatter',  // ✅ Changed from 'line' to 'scatter'
        hoverinfo: 'text',
        marker: { size: isMobile ? 8 : 10, symbol: 'triangle-down-open', color: '#bf7413' },
        text: y1Event,
        name: 'Events',
        showlegend: true,
      },
    ];

    for (let i = 0; i < eventdate.length; i++) {
      shapes.push({
        type: 'line',
        xref: 'x',
        yref: 'paper',
        x0: eventdate[i],
        y0: 0,
        x1: eventdate[i],
        y1: 1,
        line: {
          color: '#000',
          width: 0.1,
        },
      });
    }

    let layout = {
      title: title,
      showlegend: true,
      legend: isMobile ? {
        orientation: 'h',
        x: 0.5,
        xanchor: 'center',
        y: 1.15,
        yanchor: 'top',
        font: { size: 10 }
      } : {
        orientation: 'v',
        x: 1.02,
        xanchor: 'left',
        y: 1,
        yanchor: 'top',
        font: { size: 12 }
      },
      xaxis: {
        title: 'Date',
        type: 'date',  // ✅ Changed from 'Date' to 'date'
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: 2,  // ✅ Changed from '2' to 2 (number)
      },
      yaxis: {
        title: yaxis,
        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: 2,  // ✅ Changed from '2' to 2 (number)
      },
      yaxis2: {
        overlaying: 'y',
        side: 'right',
        showgrid: false,
        showticklabels: false,
        range: [0, 1],
        fixedrange: true
      },
      shapes: shapes,
      margin: isMobile ? {
        l: 50,
        r: 20,
        t: 80,
        b: 50
      } : {
        l: 80,
        r: 150,
        t: 100,
        b: 80
      },
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, data, layout);
    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }

  plotLine2(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    yaxis: string,
    stageLabel: string
  ) {
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'F1',
      marker: { color: 'red' },
    };
    const data = [
      {
        x: x,
        y: y,
        type: 'scatter',
        mode: 'markers',
        name: 'F1 - ' + stageLabel,
        marker: { color: 'red' },
        showlegend: true,
        legendgroup: 'group1',
        unselected: {
          marker: { opacity: 1 } // Keep unselected points fully visible
        },
        selected: {
          marker: { opacity: 1 } // Keep selected points fully visible
        }
      },
      //   {
      //     x: x,
      //     y: y,
      //     type: 'scatter',
      //     mode: 'markers',
      //     name: 'Stage : ' + stageLabel,
      //     marker: { color: 'red' },
      //     showlegend: true,
      //     legendgroup: 'group1',
      //     hoverinfo: 'skip',
      //   },
    ];
    let layout = {
      title: title,

      xaxis: {
        title: 'Date',
        type: 'Date',
        xaxis: { domain: [0.3, 0.7] },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },

      yaxis: {
        title: yaxis,
        titlefont: { color: 'red' },
        tickfont: { color: '#000' },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      dragmode: 'lasso',
    };

    // Plotly.newPlot(plotDiv, [trace], layout);
    Plotly.newPlot(plotDiv, data, layout);

    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }

  plotLine2WithEvents(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1Event: string[],
    eventdate,
    maxYaxisNsp,
    yaxis: string,
    stageLabel: string
  ) {
    let shapes = [];
    let NoOfEvents = [];
    let trace = {
      x: x,
      y: y,
      x1: x,
      y1: y1Event,
      name: 'F1',
      legendgroup: 'group1',
      marker: { color: 'red' },
      title: yaxis,
    };
    for (let i = 0; i < eventdate.length; i++) {
      // NoOfEvents[i] = maxYaxisNsp * 1.1;
      NoOfEvents[i] = 0.95;  // Position at 95% height instead of 100%
    }
    const data = [
      {
        x: x,
        y: y,
        type: 'scatter',
        mode: 'markers',
        name: 'F1 - ' + stageLabel,  // ✅ Combined label
        marker: { color: 'red' },
        showlegend: true,
        legendgroup: 'group1',
        unselected: {
          marker: { opacity: 1 } // Keep unselected points fully visible
        },
        selected: {
          marker: { opacity: 1 } // Keep selected points fully visible
        }
      },
      //   {
      //     x: x,
      //     y: y,
      //     type: 'scatter',
      //     mode: 'markers',
      //     marker: { color: 'red' },
      //     showlegend: true,
      //     name: 'Stage : ' + stageLabel,
      //     legendgroup: 'group1',
      //   },
      {
        x: eventdate,

        y: NoOfEvents,
        yaxis: 'y2',
        mode: 'markers',
        hoverinfo: 'text',
        marker: { size: 10, symbol: 'triangle-down-open', color: '#bf7413' },

        text: y1Event,
        showlegend: false,
      },
    ];
    for (let i = 0; i < eventdate.length; i++) {
      shapes.push({
        type: 'line',
        xref: 'x',
        yref: 'paper',
        x0: eventdate[i],
        y0: 0,
        x1: eventdate[i],
        y1: 1,
        line: {
          color: '#000',
          width: 0.1,
        },
      });
    }
    let layout = {
      title: title,
      xaxis: {
        title: 'Date',
        type: 'Date',
        xaxis: { domain: [0.3, 0.7] },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis: {
        title: yaxis,
        titlefont: { color: 'red' },
        tickfont: { color: '#000' },
       
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis2: {
        overlaying: 'y',
        side: 'right',
        showgrid: false,
        showticklabels: false,
        range: [0, 1],
        fixedrange: true
      },
      shapes: shapes,
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, data, layout);
    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }

  plotLine3(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    yaxis: string,
    stageLabel: string
  ) {
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'F1',
      marker: { color: 'green' },
    };
    const data = [
      {
        x: x,
        y: y,
        type: 'scatter',
        mode: 'markers',
        name: 'F1 - ' + stageLabel,  // ✅ Combined label
        marker: { color: 'green' },
        showlegend: true,
        legendgroup: 'group1',
        unselected: {
          marker: { opacity: 1 } // Keep unselected points fully visible
        },
        selected: {
          marker: { opacity: 1 } // Keep selected points fully visible
        }
      },
      //   {
      //     x: x,
      //     y: y,
      //     type: 'scatter',
      //     mode: 'markers',
      //     name: 'Stage : ' + stageLabel,
      //     marker: { color: 'green' },
      //     showlegend: true,
      //     legendgroup: 'group1',
      //     hoverinfo: 'skip',
      //   },
    ];

    let layout = {
      title: title,

      xaxis: {
        title: 'Date',
        type: 'Date',
        xaxis: { domain: [0.3, 0.7] },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },

      yaxis: {
        title: yaxis,

        titlefont: { color: 'green' },
        tickfont: { color: '#000' },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      dragmode: 'lasso',
    };

    // Plotly.newPlot(plotDiv, [trace], layout);
    Plotly.newPlot(plotDiv, data, layout);

    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }

  plotLine3WithEvents(
    title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1Event: string[],
    eventdate,
    maxYaxisNdf,
    yaxis: string,
    stageLabel: string
  ) {
    let shapes = [];
    let NoOfEvents = [];
    let trace = {
      x: x,
      y: y,
      x1: x,
      y1: y1Event,
      name: 'F1',
      legendgroup: 'group1',
      marker: { color: 'green' },
      title: yaxis,
    };
    for (let i = 0; i < eventdate.length; i++) {
      // NoOfEvents[i] = maxYaxisNdf * 1.1;
      NoOfEvents[i] = 0.95;
    }
    const data = [
      //   {
      //     x: x,
      //     y: y,
      //     type: 'scatter',
      //     mode: 'markers',
      //     marker: { color: 'green' },
      //     showlegend: true,
      //     name: 'F1',
      //     legendgroup: 'group1',
      //   },
      //   {
      //     x: x,
      //     y: y,
      //     type: 'scatter',
      //     mode: 'markers',
      //     marker: { color: 'green' },
      //     showlegend: true,
      //     name: 'Stage : ' + stageLabel,
      //     legendgroup: 'group1',
      //   },
      {
        x: x,
        y: y,
        type: 'scatter',
        mode: 'markers',
        name: 'F1 - ' + stageLabel,  // ✅ Combined label
        marker: { color: 'green' },
        showlegend: true,
        legendgroup: 'group1',
        unselected: {
          marker: { opacity: 1 } // Keep unselected points fully visible
        },
        selected: {
          marker: { opacity: 1 } // Keep selected points fully visible
        }
      },
      {
        x: eventdate,
        y: NoOfEvents,
        yaxis: 'y2',
        type: 'line',
        mode: 'markers',
        hoverinfo: 'text',
        marker: { size: 10, symbol: 'triangle-down-open', color: '#bf7413' },

        text: y1Event,
        showlegend: false,
      },
    ];

    for (let i = 0; i < eventdate.length; i++) {
      shapes.push({
        type: 'line',
        xref: 'x',
        yref: 'paper',
        x0: eventdate[i],
        y0: 0,
        x1: eventdate[i],
        y1: 1,
        line: {
          color: '#000',
          width: 0.3,
        },
      });
    }
    let layout = {
      title: title,

      xaxis: {
        title: 'Date',
        type: 'Date',
        xaxis: { domain: [0.3, 0.7] },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis: {
        title: yaxis,
        titlefont: { color: 'green' },
        tickfont: { color: '#000' },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis2: {
        overlaying: 'y',
        side: 'right',
        showgrid: false,
        showticklabels: false,
        range: [0, 1],
        fixedrange: true
      },
      shapes: shapes,
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, data, layout);
    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }



  //comparison graph with 2 Y axis

  plotTwoLineComparisonGraph(
    title: string,
    plotDiv: string,
    x: Date[],
    x2: Date[],
    y: number[],
    y1: number[],
    y1name,
    y2name,
    stage1Label: string,
    stage2Label: string
  ) {
    let trace = {
      x: x,
      y: y1,
      name: 'P1 - ' + stage1Label,
      type: 'scatter',
      mode: 'markers',
      // marker: { color: 'blue' },
      marker: { color: 'red' },
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };
    var trace2 = {
      y: y,
      x: x2,
      name: 'P2 - ' + stage2Label,
      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      // marker: { color: 'red' },
       marker: { color: 'blue' },
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };
    let layout = {
      title: title,

      xaxis: {
        title: 'Date',
        type: 'Date',

        domain: [0.1, 2],
      },

      yaxis: {
        title: y2name + " - " + stage2Label,

        titlefont: { color: 'red' },
        tickfont: { color: '#000' },
        linecolor: '#000',
        linewidth: '2',

        position: 0.03,
      },
      yaxis2: {
        title: y1name + " - " + stage1Label,
        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      dragmode: 'lasso',
    };

    const config = {
      modeBarButtonsToAdd: ['lasso2d'],
      displayModeBar: true,
    };
    Plotly.newPlot(plotDiv, [trace, trace2], layout);

    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }

  //comparison graph with  3 Y axis
  plotThreeLineComparisonGraph(
    title: string,
    plotDiv: string,
    x: Date[],
    x2: Date[],
    x3: Date[],
    y: number[],
    y1: number[],
    y2: number[],
    y1name,
    y2name,
    y3name,
    stage1Label: string,
    stage2Label: string,
    stage3Label: string
  ) {
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'P1 - ' + stage1Label,
      marker: { color: 'blue' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    var trace2 = {
      y: y1,
      x: x2,
      name: 'P2 - ' + stage2Label,
      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'red' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    var trace3 = {
      y: y2,
      x: x3,
      name: 'P3 - ' + stage3Label,
      yaxis: 'y3',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'green' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    let layout = {
      title: title,

      xaxis: {
        title: 'Date',
        type: 'Date',

        domain: [0.15, 4],
      },

      yaxis: {
        title: y1name + " - " + stage1Label,

        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        linecolor: '#000',
        linewidth: '2',
        position: 0.15,
      },
      yaxis2: {
        title: y2name + " - " + stage2Label,
        titlefont: { color: '#ff0000' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis3: {
        title: y3name + " - " + stage3Label,
        titlefont: { color: 'green' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.05,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, [trace, trace2, trace3], layout);
    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }

  //Comparison graph with 4 Y axis
  plotFourLineComparisonGraph(
    title: string,
    plotDiv: string,
    x: Date[],
    x2: Date[],
    x3: Date[],
    x4: Date[],
    y: number[],
    y1: number[],
    y2: number[],
    y3: number[],
    y1name,
    y2name,
    y3name,
    y4name,
    stage1Label: string,
    stage2Label: string,
    stage3Label: string,
    stage4Label: string
  ) {
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'P1 - ' + stage1Label,
      marker: { color: 'blue' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    var trace2 = {
      y: y1,
      x: x2,
      name: 'P2 - ' + stage2Label,
      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'red' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    var trace3 = {
      y: y2,
      x: x3,
      name: 'P3 - ' + stage3Label,
      yaxis: 'y3',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'green' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    var trace4 = {
      y: y3,
      x: x4,
      name: 'P4 - ' + stage4Label,
      yaxis: 'y4',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'pink' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    let layout = {
      title: title,

      xaxis: {
        title: 'Date',
        type: 'Date',

        domain: [0.2, 4],
      },

      yaxis: {
        title: y1name + " - " + stage1Label,

        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        linecolor: '#000',
        linewidth: '2',
        position: 0.2,
      },
      yaxis2: {
        title: y2name + " - " + stage2Label,
        titlefont: { color: '#ff0000' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.15,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis3: {
        title: y3name + " - " + stage3Label,
        titlefont: { color: 'green' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis4: {
        title: y4name + " - " + stage4Label,
        titlefont: { color: 'pink' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.05,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, [trace, trace2, trace3, trace4], layout);
    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }

  //Comparison graph with 5 Y axis
  plotFiveLineComparisonGraph(
    title: string,
    plotDiv: string,
    x: Date[],
    x2: Date[],
    x3: Date[],
    x4: Date[],
    x5: Date[],
    y: number[],
    y1: number[],
    y2: number[],
    y3: number[],
    y4: number[],
    y1name,
    y2name,
    y3name,
    y4name,
    y5name,
    stage1Label: string,
    stage2Label: string,
    stage3Label: string,
    stage4Label: string,
    stage5Label: string
  ) {
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: 'P1 - ' + stage1Label,
      marker: { color: 'blue' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    var trace2 = {
      y: y1,
      x: x2,
      name: 'P2 - ' + stage2Label,
      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'red' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    var trace3 = {
      y: y2,
      x: x3,
      name: 'P3 - ' + stage3Label,
      yaxis: 'y3',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'green' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    var trace4 = {
      y: y3,
      x: x4,
      name: 'P4 - ' + stage4Label,
      yaxis: 'y4',
      type: 'scatter',
      mode: 'markers',
      marker: { color: '#FAA0A0' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    var trace5 = {
      y: y4,
      x: x5,
      name: 'P5 - ' + stage5Label,
      yaxis: 'y5',
      type: 'scatter',
      mode: 'markers',
      marker: { color: '#EEDC82' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    let layout = {
      title: title,

      xaxis: {
        title: 'Date',
        type: 'Date',

        domain: [0.25, 4],
      },

      yaxis: {
        title: y1name + " - " + stage1Label,

        titlefont: { color: 'blue' },
        tickfont: { color: '#000' },
        linecolor: '#000',
        linewidth: '2',
        position: 0.25,
      },
      yaxis2: {
        title: y2name + " - " + stage2Label,
        titlefont: { color: '#ff0000' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.2,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis3: {
        title: y3name + " - " + stage3Label,
        titlefont: { color: 'green' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.15,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis4: {
        title: y4name + " - " + stage4Label,
        titlefont: { color: 'pink' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis5: {
        title: y5name + " - " + stage5Label,
        titlefont: { color: '#EEDC82' },
        tickfont: { color: '#000' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',
        position: 0.05,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, [trace, trace2, trace3, trace4, trace5], layout);
    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }

  //conductivity profile graph
  plotLineCpGraphWithDate1(
    title: string,
    plotDiv: string,
    x: string[],
    y: string[],
    date1: string,
    stage1Label: string,
  ) {
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: date1,
      marker: { color: 'blue' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    let staget = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: "Stage: " + stage1Label,
      marker: { color: 'yellow' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };

    let layout = {
      title: title,
      showlegend: true,
      xaxis: {
        title: '',
        type: '-',
        domain: [0.1, 2],
      },

      yaxis: {
        title: 'Conductivity Profile',
        titlefont: { color: 'black' },
        tickfont: { color: '#000' },
        linecolor: '#000',
        linewidth: '2',
        mode: 'lines+markers',
        type: 'scatter',
      },
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, [staget, trace], layout);

    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }
  plotLineCpGraphWithDate2(
    title: string,
    plotDiv: string,
    x: string[],
    y: string[],
    y1: string[],
    date1: string,
    date2: string,
    stage1Label: string
  ) {
    let staget = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: "Stage: " + stage1Label,
      marker: { color: 'yellow' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: date1,
      marker: { color: 'blue' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    var trace2 = {
      y: y1,
      x: x,
      name: date2,

      type: 'scatter',
      mode: 'markers',
      marker: { color: 'red' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };

    let layout = {
      title: title,
      showlegend: true,
      xaxis: {
        title: '',
        type: '',
        xaxis: { domain: [0.3, 0.7] },
      },

      yaxis: {
        title: 'Conductivity Profile',
        titlefont: { color: 'black' },
        tickfont: { color: '#000' },
        linecolor: '#000',
        linewidth: '0',
        mode: 'lines+markers',
        type: 'scatter',
      },
      yaxis2: {
        title: '',
        titlefont: { color: 'red' },
        tickfont: { color: 'red' },
        linecolor: '#000',
        linewidth: '0',
      },
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, [staget, trace, trace2], layout);

    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }
  plotLineCpGraphWithDate3(
    title: string,
    plotDiv: string,
    x: string[],
    y: string[],
    y1: string[],
    y2: string[],
    date1: string,
    date2: string,
    date3: string,
    stage1Label: string
  ) {
    let staget = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      name: "Stage: " + stage1Label,
      marker: { color: 'yellow' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    let trace = {
      x: x,
      y: y,
      xtype: '-',
      type: 'scatter',
      mode: 'markers',
      name: date1,
      marker: { color: 'blue' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    var trace2 = {
      y: y1,
      x: x,
      xtype: '-',
      name: date2,

      type: 'scatter',
      mode: 'markers',
      marker: { color: 'red' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    var trace3 = {
      y: y2,
      x: x,
      xtype: '-',
      xmode: 'markers',
      name: date3,

      type: 'scatter',
      mode: 'markers',
      marker: { color: 'green' },
      unselected: {
        marker: { opacity: 1 }
      },
      selected: {
        marker: { opacity: 1 }
      }
    };
    let layout = {
      title: title,

      xaxis: {
        title: '',
        type: '',
        xaxis: { domain: [0.3, 0.7] },
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },

      yaxis: {
        title: 'Conductivity Profile',
        titlefont: { color: 'black' },
        tickfont: { color: '#000' },
        linecolor: '#000',
        linewidth: '0',
        mode: 'lines+markers',
        type: 'scatter',
      },
      yaxis2: {
        title: '',
        titlefont: { color: 'red' },
        tickfont: { color: 'red' },
        linecolor: '#000',
        linewidth: '0',
      },
      yaxis3: {
        title: '',
        titlefont: { color: 'green' },
        tickfont: { color: 'green' },
        linecolor: '#000',
        linewidth: '0',
      },
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, [staget, trace, trace2, trace3], layout);

    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    }
  }
  plotCustomForF1andF2ForEventsFinal(

  
  title: string,
    plotDiv: string,
    x: Date[],
    y: number[],
    y1: number[],
    
    y1name,
    y2name,
  
    y1Event: string[],
    eventdate: string[],
    maxField1,
    stage1: string,
    stage2: string
    
  ) {
    let shapes = [];
    let NoOfEvents = [];
    let trace = {
      x: x,
      y: y,
      type: 'scatter',
      mode: 'markers',
      //   name: 'F1',
      name: `F1 - ${stage1}`,

      yaxis: 'y1',
      marker: { color: 'blue' },
    };
    var trace2 = {
      y: y1,
      x: x,
      //   name: 'F2',
      name: `F2 - ${stage2}`,

      yaxis: 'y2',
      type: 'scatter',
      mode: 'markers',
      marker: { color: 'red' },
      unselected: {
        marker: { opacity: 1 } // Keep unselected points fully visible
      },
      selected: {
        marker: { opacity: 1 } // Keep selected points fully visible
      }
    };
    
    for (let i = 0; i < eventdate.length; i++) {
      // NoOfEvents[i] = maxField1 * 1.1;
      NoOfEvents[i] = 0.95;
    }
    const data = [
      {
        x: x,
        y: y,
        type: 'scatter',
        mode: 'markers',
        marker: { color: 'blue' },
        showlegend: true,
        // name: 'F1',
        name: `F1 - ${stage1}`,
        unselected: {
          marker: { opacity: 1 } // Keep unselected points fully visible
        },
        selected: {
          marker: { opacity: 1 } // Keep selected points fully visible
        }
      },

      {
        x: eventdate,
        y: NoOfEvents,
        mode: 'markers',
        yaxis: 'y4',
        type: 'line',
        hoverinfo: 'text',
        marker: { size: 10, symbol: 'triangle-down-open', color: '#bf7413' },

        text: y1Event,
        showlegend: false,
        xref: 'paper',
        yref: 'paper',
      },
      trace2
      
    ];
    for (let i = 0; i < eventdate.length; i++) {
      shapes.push({
        type: 'line',
        xref: 'x',
        yref: 'paper',
        x0: eventdate[i],
        y0: 0,
        x1: eventdate[i],
        y1: 1,
        line: {
          color: '#000',
          width: 0.3,
        },
      });
    }

    let layout = {
      title: title,
      showlegend: true,
      xaxis: {
        title: 'Date',
        type: 'Date',

        domain: [0.16, 4],
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },

      yaxis: {
        // title: y1name,
        title: `${y1name} (${stage1})`,
        titlefont: { color: 'blue' },
        tickfont: { color: 'blue' },
        position: 0.15,
        side: 'left',
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      yaxis2: {
        // title: y2name,
        title: `${y2name} (${stage2})`,
        titlefont: { color: 'red' },
        tickfont: { color: 'red' },
        anchor: 'free',
        overlaying: 'y',
        side: 'left',

        position: 0.1,
        gridcolor: '#000',
        linecolor: '#000',
        linewidth: '2',
      },
      
      
      shapes: shapes,
      dragmode: 'lasso',
    };

    Plotly.newPlot(plotDiv, data, layout);
    // Add event listener for selection
    const plotElement: any = document.getElementById(plotDiv);

    if (plotElement) {
      // Handle when lasso selection is made
      plotElement.on('plotly_selected', (eventData: any) => {
        if (eventData) {
          // Create tooltip element
          const tooltip = document.createElement('div');
          tooltip.id = 'lasso-tooltip';
          tooltip.innerHTML = 'Double click to Reset Filter';
          tooltip.style.position = 'absolute';
          tooltip.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
          tooltip.style.color = 'white';
          tooltip.style.padding = '8px 12px';
          tooltip.style.borderRadius = '4px';
          tooltip.style.fontSize = '12px';
          tooltip.style.pointerEvents = 'none';
          tooltip.style.zIndex = '1000';
          tooltip.style.display = 'none';
          tooltip.style.whiteSpace = 'nowrap';

          // Remove existing tooltip if any
          const existingTooltip = document.getElementById('lasso-tooltip');
          if (existingTooltip) {
            existingTooltip.remove();
          }

          document.body.appendChild(tooltip);

          // Show tooltip on hover over the plot
          plotElement.addEventListener('mouseenter', () => {
            tooltip.style.display = 'block';
          });

          plotElement.addEventListener('mousemove', (e: MouseEvent) => {
            tooltip.style.left = (e.pageX + 15) + 'px';
            tooltip.style.top = (e.pageY + 15) + 'px';
          });

          plotElement.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none';
          });
        }
      });

      // Remove tooltip when selection is cleared
      plotElement.on('plotly_deselect', () => {
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });

      // Handle double click to deselect
      plotElement.on('plotly_doubleclick', () => {
        Plotly.restyle(plotDiv, { selectedpoints: [null] });
        const tooltip = document.getElementById('lasso-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    


}
  }
}